<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/arrow_left.png" alt="" class="logo" @click="back()">
            <span class="title">{{ $t("message.worksshop") }}</span>
            <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
        </div>
        <div class="content">
            <div class="scrollCon">
                <div class="title">
                    <span>{{title|sliceTitle(3)}}</span>
                    <span class="titleName">{{title|sliceTitle(4)}}</span>
                </div>
                <div class="list" v-if="topicData.info&&$i18n.locale=='cn'">
                    <div class="topic">
                        <span>{{topicData.info.title|sliceTitle_1(3)}}</span>
                        <span class="titleName">{{topicData.info.title|sliceTitle_1(4)}}</span>
                    </div>
                    <div class="videoCon">
                        <video :src="'http://conference2019.hanban.org/upload/'+topicData.info.video" controls v-if="topicData.info.video"></video>
                    </div>
                    <div class="newsContent" v-html="topicData.info.description">
                   
                    </div>
                    <div class="time" v-if="topicData.info.start_at">
                        <span class="leftCon">时间：</span> <span>{{topicData.info.start_at*1000|formatDate}}</span>
                    </div>
                    <div class="guestCon">
                        <span class="leftCon">主持人:</span> 
                        <div class="guestRight">
                            <span v-for="(newsItem, index) in topicData.info.presenter_list" :key="index" class="guestItem" @click="toDetail(newsItem.id)">
                                <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                                <div class="guestInfo">
                                    <div>{{newsItem.realname}}</div>
                                    <div class="guestTitle">{{newsItem.title}}</div>
                                </div>
                            </span>
                        </div>
                        
                    </div>
                    <div class="guestCon">
                        <span class="leftCon">发言人:</span> 
                        <div class="guestRight">
                            <span v-for="(newsItem, index) in topicData.info.guest_list" :key="index" class="guestItem"  @click="toDetail(newsItem.id)">
                                <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                                <div class="guestInfo">
                                    <div>{{newsItem.realname}}</div>
                                    <div class="guestTitle">{{newsItem.title}}</div>
                                </div>
                            </span>
                        </div>

                    </div>
                
            </div>
            <div class="list" v-if="topicData.info&&$i18n.locale=='en'">
                    <div class="topic">
                        <span>{{topicData.info.title_en|sliceTitle_1(3)}}</span>
                        <span class="titleName">{{topicData.info.title_en|sliceTitle_1(4)}}</span>
                    </div>
                    <div class="videoCon">
                        <video :src="'http://conference2019.hanban.org/upload/'+topicData.info.video" controls v-if="topicData.info.video"></video>
                    </div>
                    <div class="newsContent" v-html="topicData.info.description_en">
                   
                    </div>
                    <div class="time" v-if="topicData.info.start_at">
                        <span class="leftCon">时间：</span> <span>{{topicData.info.start_at*1000|formatDate}}</span>
                    </div>
                    <div class="guestCon">
                        <span class="leftCon">主持人:</span> 
                        <div class="guestRight">
                            <span v-for="(newsItem, index) in topicData.info.presenter" :key="index" class="guestItem" @click="toDetail(newsItem.id)">
                                <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                                <div class="guestInfo">
                                    <div>{{newsItem.realname_en}}</div>
                                    <div class="guestTitle">{{newsItem.title_en}}</div>
                                </div>
                            </span>
                        </div>
                        
                    </div>
                    <div class="guestCon">
                        <span class="leftCon">发言人:</span> 
                        <div class="guestRight">
                            <span v-for="(newsItem, index) in topicData.info.guest_list" :key="index" class="guestItem"  @click="toDetail(newsItem.id)">
                                <!-- <img :src="'http://conference2019.hanban.org/upload/'+ newsItem.avatar" alt=""> -->
                                <div class="guestInfo">
                                    <div>{{newsItem.realname_en}}</div>
                                    <div class="guestTitle">{{newsItem.title_en}}</div>
                                </div>
                            </span>
                        </div>

                    </div>
                
            </div>

            </div>
                
        </div>
        <mt-popup
        v-model="navbarShow" 
        position="right" class="secondPage">
            <m_navbar @close="close"/>
        </mt-popup>
    </div>
</template>

<script>
import m_navbar from './m_navbar'
export default {
    name: 'm_topicdetail',
    components: {
        m_navbar
    },
    data: function () {
        return {
            navbarShow: false,
            topic_id:null,
            title: '',
            topicData: {}
        }
    },
        // 截取论坛
    filters: {
        sliceTitle (val,num) {
            if(num == 3){
                return val.slice(0,num)
            }else {
                return val.slice(num ,val.length)
            }
            
        },
        sliceTitle_1 (val,num) {
            if(num == 3){
                return val.slice(0,num)
            }else {
                return val.slice(num-1 ,val.length)
            }
            
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
        back () {
            this.$router.push({
                path: '/m_page/m_mainpage',
                query: {
                    to: 1
                }
            })
        },
        showNavBar () {
            this.navbarShow = true
            },
        close () {
            this.navbarShow = false
        },
        toDetail(item) {
            window.open(item)
        },
        getNewsList(id) {
        this.$utils
            .get("forum/api/getTopic", {
                lang: this.language,
                topic_id: id
            })
            .then(res => {
                this.topicData = res.data.data
                this.topicData.info.description = this.htmlDecode(this.topicData.info.description)
            });
        },
        toDetail (id) {
            this.$router.push({
                path: '/pcpage/detailpage/guestdetail',
                query: {
                    id: id
                }
            })
        },
        htmlDecode(text){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
        },
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          this.getNewsList(this.topic_id)
      }
    },
  mounted() {
    this.topic_id = this.$route.query.topic_id
    this.title = this.$route.query.title
    this.getNewsList(this.topic_id)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 0.22rem;
            margin: 0 0.3rem 0 0.54rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        width: 100%;
        background-color: #fff;
        height: calc(100% - 1.4rem);
        overflow: hidden;
        .scrollCon {
            height: 100%;
            overflow-y: auto;
            .title {
                font-size: 0.33rem;
                font-weight: bold;
                padding: 0.45rem 0.4rem;
                background-color: #e1eef3;
                span:first-child {
                    color: #1c58c1;
                    margin-right: 0.1rem;
                }
                span:last-child {
                    color: #282828;

                }
            }
            .list {
                .topic {
                    font-size: 0.41rem;
                    padding: 0.45rem 0.4rem;
                    span:first-child {
                        color: #1c58c1;
                        margin-right: 0.1rem;
                    }
                    span:last-child {
                        color: #282828;

                    }
                }
                .videoCon {
                    width: 100%;
                    video {
                        width: 100%;
                    }
                }
                .newsContent {
                    padding: 0.51rem;
                    font-size: 0.24rem;
                    color: #282828;
                    /deep/ p {
                        font-size: 0.18rem;
                        color: #282828;
                        line-height: 1.6;
                        margin: 0.1rem auto;
                        strong {
                            font-weight: bold;
                        }
                    }

                    /deep/ video {
                        display: block;
                        width: 100%;
                        
                        margin: 0 auto;
                    }
                }
                .time {
                    margin: 0.31rem 0.47rem;
                    font-size: 0.24rem;
                    color: #282828;
                    span:first-child {
                        margin-right: 0.47rem;
                    }
                }
                .guestCon {
                    margin-bottom: 0.4rem;
                    margin-top: 0.2rem;
                    .leftCon {
                        display: inline-block;
                        width: 1.5rem;
                        text-align: right;
                        padding: 0;
                        vertical-align: top;
                        font-size: 0.24rem;
                    }
                    .guestRight {
                        vertical-align: top;
                        display: inline-block;
                        width: calc(100% - 1.5rem);
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                        box-sizing: border-box;
                        .guestItem {
                            display: inline-block;
                            margin-bottom: 0.2rem;
                            // width: calc(100% - 1.5rem);
                            img {
                                width: 0.9rem;
                                height: 0.9rem;
                                border-radius: 50%;
                                margin-right: 0.2rem;
                            }
                            .guestInfo {
                                display: inline-block;
                                vertical-align: top;
                                word-break: break-all;
                                div:first-child {
                                    font-size: 0.24rem;
                                    margin-bottom: 0.2rem;
                                    color: #282828;
                                    font-weight: bold;
                                }
                                div:last-child {
                                    font-size: 0.20rem;
                                    color: #282828;
                                }
                            }
                        }
                    }
                }
                
            }

        }



    }
}
.secondPage {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-image: url(../img/m/m_bg.png);
    background-size: cover;
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
